import { useEffect, useState } from 'react'

export const usePhotoFullScreen = (props) => {
    const { getPhotoTagList, updatePhotoTagList, tagPhotoDetails, tagListApi, initImageList } =
        props
    const [selectedImage, setSelectedImage] = useState('')
    const [showPhotoFullScreen, setShowPhotoFullScreen] = useState(false)
    const [tagList, setTagList] = useState([])
    const [newTagPosition, setNewTagPosition] = useState<{ x: number; y: number }>({ x: 0, y: 0 })
    const [tagOnImageList, setTagOnImageList] = useState([])
    const [selectedImageInfo, setSelectedImageInfo] = useState<any>({
        title: '',
        position: 0,
    })
    const [enabledTag, setEnabledTag] = useState(false)
    const [enabledEdit, setEnabledEdit] = useState(false)
    const [uploadedImageList, setUploadedImageList] = useState<any[]>(initImageList || [])
    const [imageList, setImageList] = useState<any[]>([])
    const [slide, setSlide] = useState(0)
    const [editLoading, setEditLoading] = useState(false)
    const [editImageId, setEditImageId] = useState('')
    const [editImageExt, setEditImageExt] = useState('')
    const [reloadData, setReloadData] = useState(false)
    const [selectedTag, setSelectedTag] = useState('')

    const onAddTag = (tag: string) => {
        setEditLoading(true)
        updatePhotoTagList(
            {
                attachmentId: editImageId,
                tags: [
                    ...tagOnImageList.map((t) => ({
                        name: t.tag,
                        x: t.x,
                        y: t.y,
                    })),
                    { name: selectedTag, x: newTagPosition.x, y: newTagPosition.y },
                ],
            },
            () => setEditLoading(false)
        )
        setTagOnImageList([...tagOnImageList, { tag, x: newTagPosition.x, y: newTagPosition.y }])
        setNewTagPosition({ x: 0, y: 0 })
    }

    const onRemoveTag = (tag: any) => {
        setEditLoading(true)
        updatePhotoTagList(
            {
                attachmentId: editImageId,
                tags: tagOnImageList
                    .filter((t) => t.tag !== tag.tag)
                    .map((t) => ({
                        name: t.tag,
                        x: t.x,
                        y: t.y,
                    })),
            },
            () => setEditLoading(false)
        )
        setTagOnImageList(tagOnImageList.filter((t) => t.x !== tag.x && t.y !== tag.y))
    }

    const onNewTagPosition = (value) => setNewTagPosition(value)
    const onCloseFullScreen = () => {
        setShowPhotoFullScreen(false)
        setSelectedImage('')
        setEnabledEdit(false)
        setEnabledTag(false)
    }

    const previousImage = () => {
        if (slide > 0) {
            setSlide(slide - 1)
            setSelectedImage(
                uploadedImageList.length > 0
                    ? uploadedImageList[slide - 1].url
                    : imageList[slide - 1].photo.url
            )
        }
    }

    const nextImage = () => {
        if (slide < (uploadedImageList.length || imageList.length) - 1) {
            setSlide(slide + 1)
            setSelectedImage(
                uploadedImageList.length > 0
                    ? uploadedImageList[slide + 1].url
                    : imageList[slide + 1].photo.url
            )
        }
    }

    const onExpandImage = (photo: { name: string; url: string; id?: string; ext?: string }) => {
        getPhotoTagList && getPhotoTagList()
        setSelectedImageInfo({
            title: photo.name,
            position: slide + 1,
        })
        setEditImageId(photo.id)
        setEditImageExt(photo.ext)
        setSelectedImage(photo.url)
        setShowPhotoFullScreen(true)
    }

    const onTag = (params: { url: string; name: string; position: number }) => {
        onExpandImage(params)
        setEnabledTag(true)
    }
    const onEdit = (params: {
        url: string
        name: string
        position: number
        id?: string
        ext?: string
    }) => {
        setSelectedImageInfo({
            title: params.name,
            position: params.position,
        })
        setEditImageId(params.id)
        setEditImageExt(params.ext)
        setSelectedImage(params.url)
        setEnabledEdit(true)
        setShowPhotoFullScreen(true)
    }

    useEffect(() => {
        setSelectedImageInfo({
            title:
                uploadedImageList.length > 0
                    ? uploadedImageList[slide].name
                    : imageList[slide]?.photo.name,
            position: slide + 1,
        })
    }, [slide])

    useEffect(() => {
        setTagOnImageList(tagPhotoDetails || [])
    }, [tagPhotoDetails])

    useEffect(() => {
        if (!!selectedTag) onAddTag(selectedTag)
    }, [selectedTag])

    useEffect(() => {
        setTagList(
            tagListApi?.map((t) => ({
                label: t,
                command: setSelectedTag.bind(null, t),
            }))
        )
    }, [tagListApi])

    return {
        imageList,
        setImageList,
        uploadedImageList,
        setUploadedImageList,
        selectedImage,
        setSelectedImage,
        selectedImageInfo,
        setSelectedImageInfo,
        enabledEdit,
        setEnabledEdit,
        enabledTag,
        setEnabledTag,
        tagList,
        setTagList,
        newTagPosition,
        tagOnImageList,
        onAddTag,
        onRemoveTag,
        onNewTagPosition,
        onCloseFullScreen,
        previousImage,
        nextImage,
        slide,
        setSlide,
        editLoading,
        setEditLoading,
        onExpandImage,
        onTag,
        onEdit,
        showPhotoFullScreen,
        reloadData,
        setReloadData,
        editImageExt,
        editImageId,
        selectedTag,
        setSelectedTag,
    }
}
